import common from './common';
import overview from './overview';
import comparasion from './comparasion';
import engagement from './engagement';
import monetization from './monetization';
import realtime from './realtime';
import wow from './wow';
import benchmark from './benchmark';
import funnel from './funnel';
import benchmarkComponentMap from '@/pages/benchmark/_config/compConfig';
import studioComponentMap from '@/pages/home/_config/compConfig';
import changeAnalysis from './changeAnalysis';
import plugin from './plugin';
import eventAnalysis from './eventAnalysis';
import report from './report';
import performance from './performance';

const componentMap: any = {
  ...common,
  ...overview,
  ...comparasion,
  ...engagement,
  ...monetization,
  ...realtime,
  ...wow,
  ...benchmark,
  ...funnel,
  ...benchmark,
  ...benchmarkComponentMap,
  ...studioComponentMap,
  ...changeAnalysis,
  ...plugin,
  ...eventAnalysis,
  ...report,
  ...performance,
};

export default componentMap;
